import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatStringRepseTitulo'
})
export class FormatStringPipe implements PipeTransform {

  transform(value: string): string {
    //si la cadena contine ; remplazarlo por ''
    value = value.replace(/;/g, '');

    // Verificar si la cadena tiene el formato esperado
    //modificar el regex para que tambien acepte este formato: "2418 - Repse_empresa_qualitas_qualitas - Expediente Del Proveedor"
    const regex = /^(\d+) - [\w_]+_(\d{4})_(\w+) -/;
    //
    const match = value.match(regex);

    if (match) {
      console.log(match);
      const id = match[1];
      let year = match[2] || '';
      let month = this.capitalizeFirstLetter(match[3] || '');

      if (month === '') {
        month = sessionStorage.getItem('empresa');
      }

      if (year === '') {
        year = " - Expediente Proveedor";
      }

      let titulo = `ID: ${id} ${month} ${year}`;
      sessionStorage.setItem('tituloExpedientePipe',titulo );
      return `ID: ${id} ${month} ${year}`;
    } else {
      const regex = /^(\d+) - [\w_]+(?:_(\w+))*(?:_(\d{4}))? -/;
      const match = value.match(regex);
      if(match == null)return "";
      console.log(match);
      const id = match[1];
      let year = match[2] || '';
      let month = this.capitalizeFirstLetter(match[3] || '');

      if (month === '') {
        month = sessionStorage.getItem('empresa');
      }

      if (year === '') {
        year = " - Expediente Proveedor";
      }

      let titulo = `ID: ${id} ${month} ${year}`;
      sessionStorage.setItem('tituloExpedientePipe',titulo );

      return `ID: ${id} ${month} ${year}`;

    }
  }

  private capitalizeFirstLetter(string: string): string {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }
}